import React from 'react';
import styled from 'styled-components';
import { Col, Row } from 'reactstrap';
import BarChartComponent from '../charts/BarChartComponent';
import PieChartComponent from '../charts/PieChartComponent';
import { BarChartTypes, PieChartTypes } from '../charts/ChartTypes';
import { Link } from 'react-scroll';



const AppContainer = styled.div`
  text-align: center;
`;

const Header = styled.header`
  background-color: #282c34;
  min-height: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
`;

const Main = styled.main`
  padding: 20px;
`;

const Section = styled.section`
  margin-bottom: 40px;
`;

const ActionItem = styled.div`
  margin: 20px 0;
  text-align: left;
`;


const LinkIcon = styled(Link)`
  font-size: 16px;
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
`;


const NpsReportSummary = ({ reportData }) => {



  return (
    <AppContainer>
      <Header>
        <h1>NPS Summary Report</h1>
      </Header>
      <Main>
        <Section>
          <h2>{reportData.report_title}</h2>
          {reportData.report_data.filter(a=>a.only_for_executive_summary).map((report, index) => (
            <ActionItem>
              {report.title && <h3 style={{ fontSize: '1rem',fontWeight:'700' }}>{report.title} </h3>}
              <Row>
                {report.report_data.map((chart, index) => (
                  <Col key={'charts_' + index.toString()}>
                    <h5>{chart.chart_data.title}</h5>
                    {BarChartTypes.indexOf(chart.chart_definition.report_element_type) !== -1 &&
                      <BarChartComponent data={chart.chart_data.values} />}
                    {PieChartTypes.indexOf(chart.chart_definition.report_element_type) !== -1 && <PieChartComponent
                      data={chart.chart_data.values} />}
                  </Col>
                ))}
              </Row>
            </ActionItem>
          ))}
          <h2  style={{ fontSize: '1.4em',textAlign:'left' }}>Action Items</h2>
          {reportData.report_data.filter(a=>!a.only_for_executive_summary).map((report, index) => (
            <ActionItem>
              {report.action_item_text && <h3 style={{ fontSize: '1em' }}><span>{(index+1).toString()+'. '+report.action_item_text} </span>
                <LinkIcon to={report.link_to} containerId="main-body-container">&#128279;</LinkIcon></h3>}
              <Row>
                {report.report_data.map((chart, index) => (
                  <Col key={'charts_' + index.toString()}>
                    <h5>{chart.chart_data.title}</h5>
                    {BarChartTypes.indexOf(chart.chart_definition.report_element_type) !== -1 &&
                      <BarChartComponent data={chart.chart_data.values} />}
                    {PieChartTypes.indexOf(chart.chart_definition.report_element_type) !== -1 && <PieChartComponent
                      data={chart.chart_data.values} />}
                  </Col>
                ))}
              </Row>
            </ActionItem>
          ))}
        </Section>

      </Main>
    </AppContainer>
  );
};

export default NpsReportSummary;